import React, { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Formik } from 'formik';
import axios from 'axios';
import * as Yup from 'yup';
import {
  AppDatePicker,
  AppSingleSelect,
  AppTextArea,
} from '@/layout/AppComponents';
import { axiosPath } from '../../../../../../routing/helpers/router';
import useIsMounted from '../../../../../components/hooks/useIsMounted';
import errorHandler from '@/layout/components/error/ErrorHandler';

export default function InecoRiskManagerRiskInterventionForm({
  riskID,
  actionID,
  interventionID,
  tracking,
  onShowDeleteInterventionModal,
  onCloseModals,
  onReloadTab,
}) {
  const { moduleBridgeHex } = useParams();
  const dispatch = useDispatch();
  const isMounted = useIsMounted();
  const moduleData = useSelector(
    (s) => s?.module?.[moduleBridgeHex]?.moduleData
  );
  const validationSchema = Yup.object().shape({
    description: Yup.string().required('Requerido'),
    date: Yup.string().required('Requerido'),
  });

  // > SAVE
  const handleSave = useCallback(
    async (values) =>
      axios
        .post(
          axiosPath(
            interventionID === 0
              ? "api_r_user_module_inecoRiskManager_risk_intervention_add"
              : "api_r_user_module_inecoRiskManager_risk_intervention_edit"
          ),
          {
            moduleBridgeHex,
            riskID,
            actionID,
            interventionID,
            ...values,
          }
        )
        .then(() => {
          if (isMounted.current) {
            onCloseModals();
            onReloadTab();
          }
        })
        .catch((e) => dispatch(errorHandler(e))),
    [moduleBridgeHex, riskID, actionID, interventionID]
  );
  // < SAVE

  return (
    <Formik
      validateOnChange={false}
      validateOnBlur={false}
      validationSchema={validationSchema}
      initialValues={{
        description:
          tracking
            ?.find((a) => a?.id === actionID)
            ?.interventions?.find((i) => i?.id === interventionID)
            ?.description || '',
        date:
          tracking
            ?.find((a) => a?.id === actionID)
            ?.interventions?.find((i) => i?.id === interventionID)?.date || '',
      }}
      onSubmit={handleSave}
    >
      {({ setFieldValue, handleSubmit, values, errors, isSubmitting }) => (
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-12">
              <AppTextArea
                title="Descripción"
                onChange={(v) => setFieldValue('description', v)}
                value={values.description}
                error={errors.description}
                resize
                height="240px"
                isClearable
                required
              />
            </div>
            <div className="col-lg-6">
              <AppDatePicker
                title="Fecha"
                value={values?.date}
                error={errors.date}
                placeholder="DD/MM/YYYY"
                onChange={(opt) => setFieldValue('date', opt)}
                popperClassName="react-datepicker-popper react-datepicker-popper-1000"
                isClearable
                showYearDropdown
                showMonthDropdown
                hasToggleType
                required
              />
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-12">
              <button
                type="submit"
                className="btn btn-sm btn-success float-right"
                disabled={isSubmitting}
              >
                {interventionID !== 0 ? 'Editar' : 'Crear'}
              </button>
              {interventionID !== 0 && (
                <button
                  type="button"
                  className="btn btn-sm btn-danger float-right mr-2"
                  onClick={() => onShowDeleteInterventionModal(interventionID)}
                >
                  Eliminar
                </button>
              )}
              <button
                type="button"
                className="btn btn-sm btn-outline-danger float-right mr-2"
                onClick={onCloseModals}
              >
                Cancelar
              </button>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
}
